require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createNumberArray_1 = require("../utilities/createNumberArray");

function rotatePoints(ns, count) {
  var len = ns.length;
  var rightLen = len - count;
  var buffer = createNumberArray_1.createNumberArray(count);
  var i;

  for (i = 0; i < count; i++) {
    buffer[i] = ns[i];
  }

  for (i = count; i < len; i++) {
    ns[i - count] = ns[i];
  }

  for (i = 0; i < count; i++) {
    ns[rightLen + i] = buffer[i];
  }
}

exports.rotatePoints = rotatePoints;